export default __webpack_public_path__ + "content/media/16.c18c9682.jpg";